import PropTypes from "prop-types";
import { isValidElement, useContext } from "react";
import TableContext from "./TableContext";
import Cell from "./Cell";
import Row from "./Row";

function HeaderFromColumnConfig({ header }) {
  const Component = header.column.columnDef.header;

  if (typeof Component === "string") {
    return (
      <Cell key={header.id} header>
        {Component}
      </Cell>
    );
  } else if (isValidElement(Component)) {
    return Component;
  } else {
    return <Component key={header.id} headerData={header} />;
  }
}

export default function Header({ children, className, id, sticky = false }) {
  const { table } = useContext(TableContext);

  const classNames = ["lds-table-header"];
  let childrenToRender = null;

  if (children) {
    childrenToRender = children;
  } else {
    const headers = table.getFlatHeaders();

    childrenToRender = (
      <Row header>
        {headers.map((header) => (
          <HeaderFromColumnConfig key={header.id} header={header} />
        ))}
      </Row>
    );
  }

  if (sticky) {
    classNames.push("sticky")
  }

  if (className) {
    classNames.push(className)
  }

  // If onClick given, add the class "selectable".

  return (
    <thead
      className={classNames.join(" ")}
      id={id}
      data-testid={id}
      role="tableheader"
    >
      {childrenToRender}
    </thead>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  id: PropTypes.string,
  sticky: PropTypes.bool
};
